import { render, staticRenderFns } from "./setting-email.vue?vue&type=template&id=5f594bb5"
import script from "./setting-email.vue?vue&type=script&lang=js"
export * from "./setting-email.vue?vue&type=script&lang=js"
import style0 from "./setting-email.vue?vue&type=style&index=0&id=5f594bb5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports